import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import Asterisk from '@atoms/Asterisk';
import { getFundsState } from '../../reducers/FoundationDonationReducer';

export const FundsInfo = ({ funds, selectedFund, onFundChange }) => (
    <fieldset>
        <legend className="mb-0" htmlFor="fundID">
            Foundation
            <Asterisk />
        </legend>

        <p className="small">
            (Your donation will support our general fund unless you specify otherwise from the options below)
        </p>

        <Field
            as="select"
            name="fund"
            id="fundID"
            value={selectedFund}
            onChange={event => {
                const fundCode = event.target.value;
                const fundObject = funds.find(fund => fund.code === fundCode);
                onFundChange(event, fundObject);
            }}
        >
            {funds.map(fund => (
                <option value={fund.code} key={fund.id}>
                    {fund.name}
                </option>
            ))}
        </Field>
    </fieldset>
);

FundsInfo.propTypes = {
    funds: PropTypes.array,
    selectedFund: PropTypes.string,
    onFundChange: PropTypes.func.isRequired,
};

// -----------------------------
// Connect Redux
// -----------------------------

const mapStateToProps = state => ({
    funds: getFundsState(state),
});

const mapDispatchToProps = dispatch => ({
    //
});

export default connect(mapStateToProps, mapDispatchToProps)(FundsInfo);
